// extracted by mini-css-extract-plugin
module.exports = {"title":"RedoModal_title__2813K","description":"RedoModal_description__27i8b"};